import { ButtonIconSizeMap, sizeVariantsArray, themePaletteArray } from "../shared/theme.types";


const host_attr = [
  // States
  'disabled',
  // Style variant
  'regular',
  'emphasis',
  'stroke',
  'plain',
  // Aditional components
  'iconRight',
  'iconLeft',
  // Custom sizing
  'pill',
];

export const BUTTON_HOST_ATTRIBUTES = host_attr.concat(
  themePaletteArray,
  sizeVariantsArray,
);


export const BUTTON_SIZES = sizeVariantsArray;
export type ButtonSize = keyof typeof ButtonIconSizeMap;
